import { toast } from 'react-toastify';

const typeMap = {
  success: 'success',
  danger: 'error',
  info: 'info',
  warning: 'warning',
  default: 'default'
};

const Toast = {
  notify: (opts) => {
    const { message, title, type = 'default', ...rest } = opts;
    const toastType = typeMap[type] || 'default';
    const content = title ? `${title}: ${message}` : message;

    if (toastType === 'default') {
      toast(content, {
        position: 'bottom-right',
        autoClose: 5000,
        ...rest
      });
    } else {
      toast[toastType](content, {
        position: 'bottom-right',
        autoClose: 5000,
        ...rest
      });
    }
  }
};

export default Toast;
